import React from 'react'
import { ControlLabel } from 'react-bootstrap'

class FileInput extends React.Component {
    constructor(props) {
        super(props)
        this.onChange = this.onChange.bind(this)
    }

    onChange(e) {
        const { input: { onChange } } = this.props
        onChange(e.target.files[0])
    }

    render() {
        console.log(this.props.meta)
        return (
            <div className="form__file_input_field">
                <ControlLabel className='form__label'>
                    {this.props.label}
                    {this.props.optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
                </ControlLabel>
                <input type="file" className="form__file-input" onChange={this.onChange} />
                {this.props.meta.touched && (
                    <small className='form__file_error'>{this.props.meta.error}</small>
                )}
            </div>
        )
    }
}

export default FileInput



// WEBPACK FOOTER //
// ./src/forms/_fileInput.jsx